import React from "react";

const About = () => {
  return (
    <div style={{ backgroundColor: "#f8f9fa", padding: "100px 20px" }}>
      {/* Container */}
      <div className="container">
        {/* Heading */}
        <div className="text-center mb-5">
          <h1
            className="fw-bold"
            style={{
              fontSize: "35px",
              color: "#153555",
              lineHeight: "1.2",
              // textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
            }}
          >
            About Us
          </h1>
          <p
            style={{
              fontSize: "16px",
              color: "#555555",
              maxWidth: "700px",
              margin: "32px auto 0 auto",
              lineHeight: "1.7",
            }}
          >
            Our company was officially registered in 2025, with its framework and core vision established earlier in 2020. Built on a strong foundation of creativity and technology, we aim to deliver innovative digital solutions that combine strategic thinking with impactful design and development.
          </p>
        </div>

        {/* Founder Section */}
        <div className="text-center" style={{ maxWidth: "800px", margin: "0 auto" }}>
          <p
            style={{
              fontSize: "16px",
              color: "#555555",
              lineHeight: "1.7",
            }}
          >
            The company was founded by <strong>Janam Maharjan</strong>, a Software Developer, and <strong>Trishna Dangol</strong>, Creative Head. Bringing together technical expertise and creative leadership, the founders share a unified vision of creating meaningful digital experiences through collaboration, innovation, and quality-driven execution.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;